export const ActionIcon = ({ type, size = 24, color }) => {
  const icons = {
    action: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
      >
        <path
          d="M9.66406 9.99967C9.66406 10.2207 9.75186 10.4326 9.90814 10.5889C10.0644 10.7452 10.2764 10.833 10.4974 10.833C10.7184 10.833 10.9304 10.7452 11.0867 10.5889C11.2429 10.4326 11.3307 10.2207 11.3307 9.99967C11.3307 9.77866 11.2429 9.5667 11.0867 9.41042C10.9304 9.25414 10.7184 9.16634 10.4974 9.16634C10.2764 9.16634 10.0644 9.25414 9.90814 9.41042C9.75186 9.5667 9.66406 9.77866 9.66406 9.99967Z"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.66406 15.833C9.66406 16.054 9.75186 16.266 9.90814 16.4223C10.0644 16.5785 10.2764 16.6663 10.4974 16.6663C10.7184 16.6663 10.9304 16.5785 11.0867 16.4223C11.2429 16.266 11.3307 16.054 11.3307 15.833C11.3307 15.612 11.2429 15.4 11.0867 15.2438C10.9304 15.0875 10.7184 14.9997 10.4974 14.9997C10.2764 14.9997 10.0644 15.0875 9.90814 15.2438C9.75186 15.4 9.66406 15.612 9.66406 15.833Z"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.66406 4.16634C9.66406 4.38735 9.75186 4.59932 9.90814 4.7556C10.0644 4.91188 10.2764 4.99967 10.4974 4.99967C10.7184 4.99967 10.9304 4.91188 11.0867 4.7556C11.2429 4.59932 11.3307 4.38735 11.3307 4.16634C11.3307 3.94533 11.2429 3.73337 11.0867 3.57709C10.9304 3.42081 10.7184 3.33301 10.4974 3.33301C10.2764 3.33301 10.0644 3.42081 9.90814 3.57709C9.75186 3.73337 9.66406 3.94533 9.66406 4.16634Z"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    plus: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M7.99844 2.64062V14.17M2.39844 8.24062H13.5984"
          stroke="url(#paint0_linear_2405_12597)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2405_12597"
            x1="1.67359"
            y1="12.2625"
            x2="14.7256"
            y2="12.4961"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
        </defs>
      </svg>
    ),
    userIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <g clipPath="url(#clip0_2880_70159)">
          <path
            d="M10 10.834C10.663 10.834 11.2989 10.5706 11.7678 10.1018C12.2366 9.63291 12.5 8.99703 12.5 8.33398C12.5 7.67094 12.2366 7.03506 11.7678 6.56622C11.2989 6.09738 10.663 5.83398 10 5.83398C9.33696 5.83398 8.70107 6.09738 8.23223 6.56622C7.76339 7.03506 7.5 7.67094 7.5 8.33398C7.5 8.99703 7.76339 9.63291 8.23223 10.1018C8.70107 10.5706 9.33696 10.834 10 10.834Z"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 2.5C16 2.5 17.5 4 17.5 10C17.5 16 16 17.5 10 17.5C4 17.5 2.5 16 2.5 10C2.5 4 4 2.5 10 2.5Z"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 16.709V16.6673C5 15.7833 5.35119 14.9354 5.97631 14.3103C6.60143 13.6852 7.44928 13.334 8.33333 13.334H11.6667C12.5507 13.334 13.3986 13.6852 14.0237 14.3103C14.6488 14.9354 15 15.7833 15 16.6673V16.709"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2880_70159">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  };

  return icons[type];
};

export default ActionIcon;
